import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelectLanguage } from '../../../hooks/global/Languages';

const DropDown = ({ value = null, profiles = [], groups = [], onSelect = null }) => {

  const { t, i18n } = useTranslation();
  const lng = i18n.language.toUpperCase();

  const { selectTextByLanguage } = useSelectLanguage();

  const [selectedItem, setSelectedItem] = useState(value);
  const [selectedName, setSelectedName] = useState(value);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedGroupName,  setSelectedGroupName] = useState(null);

  useEffect(() => {
    if(value) setSelectedItem(value);
    if(selectedItem) {
      
      if(selectedGroup === 'COMPANY') {
        setSelectedName(`${selectTextByLanguage(selectedItem.name, lng)}`)
        setSelectedGroupName(t('admin.common.exp'));
      } else {
        setSelectedName(`${selectTextByLanguage(selectedItem.name, lng)}`);
        setSelectedGroupName(selectedGroup.name);
      }
    }
  }, [value,t]);

  // Handle profile selection
  const handleProfileSelect = (profileId) => {
    const selected = profiles.find((profile) => profile.id === profileId);
    if (selected) {
      setSelectedGroup('COMPANY');
      setSelectedItem(selected);
      setSelectedName(`${selectTextByLanguage(selected.name, lng)}`);
      setSelectedGroupName(t('admin.common.exp'));
      onSelect?.(selected);
    }
  };

  // Handle product selection
  const handleProductSelect = (productId, groupName) => {
    const group = groups.find((group) => group.products.some((product) => product.id === productId));
    const selectedProduct = group?.products.find((product) => product.id === productId);
    if (selectedProduct) {
      setSelectedGroup(group);
      setSelectedItem(selectedProduct);
      setSelectedName(`${selectTextByLanguage(selectedProduct.name, lng)}`);
      setSelectedGroupName(groupName);
      onSelect?.(selectedProduct);
    }
  };

  return (
    <DropdownButton
  className="artur-dropdown"
  id="selectCompanyDropdown"
  title={selectedName ? (<>{selectedGroupName}: <strong>{selectedName}</strong></>) : t('admin.report.choMod')}>
      {/* Static disabled item */}
      <Dropdown.ItemText className="dropdown-disabled">
        {t('admin.common.exp')}
      </Dropdown.ItemText>

      {/* Profile dropdown items */}
      {profiles.map((profile) => (
        <Dropdown.Item
          key={profile.id}
          eventKey={profile.id}
          onClick={() => handleProfileSelect(profile.id)}
          className="dropdown-item"
        >
          {profile.name}
        </Dropdown.Item>
      ))}

      {/* Group and product dropdown items */}
      {groups.map((group) => (
        group.products?.length > 0 && (
          <React.Fragment key={group.id}>
            <Dropdown.ItemText className="dropdown-disabled" disabled>
              {group.name}
            </Dropdown.ItemText>
            {group.products.map((product) => (
              <Dropdown.Item
                key={product.id}
                eventKey={product.id}
                onClick={() => handleProductSelect(product.id, group.name)}
                className="dropdown-item"
              >
                {product.source_id}
              </Dropdown.Item>
            ))}
          </React.Fragment>
        )
      ))}
    </DropdownButton>
  );
};

DropDown.propTypes = {
  profiles: PropTypes.array,
  groups: PropTypes.array
};

export default DropDown;
